import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createAppStoreButtons } from './AppStoreButtons';
import { BASE_CLASSNAME } from './Constants';
createComponents(".".concat(BASE_CLASSNAME), createAppStoreButtons, NO_PATTERN_BUSINESS_LOGIC);
